<template>
  <div class="roleBox">
    <Form ref="searchForm" :label-width="180" :model="formCustom" inline>
      <Form-item label="姓名：">
        <Input v-model="formCustom.employeeRealName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="证件号码：">
        <Input v-model="formCustom.employeeIdNumber" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="手机号：">
        <Input v-model="formCustom.employeeMobilephone" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="厂站：">
        <Cascader v-model="formCustom.deptId" :data="tableDataDeptList" change-on-select filterable
                  not-found-text='暂无下级数据，请创建'
                  style="width: 200px" @on-change="changedeptId"></Cascader>
      </Form-item>
      <Form-item label="岗位：">
        <Input v-model="formCustom.employeeResponsibilitie" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="工种：">
        <Input v-model="formCustom.employeeWorktypeName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="员工类型：">
        <Select v-model="formCustom.employeeJobType" clearable filterable style="width: 200px">
          <Option value="1">全职</Option>
          <Option value="2">兼职</Option>
          <Option value="3">实习</Option>
        </Select>
      </Form-item>
      <Form-item label="用工形式：">
        <Select v-model="formCustom.employeeJobForm" clearable filterable style="width: 200px">
          <Option value="1">自有</Option>
          <Option value="2">外包</Option>
          <Option value="3">派遣</Option>
          <Option value="4">项目</Option>
        </Select>
      </Form-item>
      <Form-item label="在职状态：" prop="roleName">
        <Select v-model="formCustom.employeeIsOnJob" clearable filterable style="width: 200px">
          <Option value="1">在职</Option>
          <Option value="0">离职</Option>
        </Select>
      </Form-item>
      <Form-item label="入职日期：">
        <DatePicker placeholder="请选择" placement="bottom-end" style="width: 200px"
                    type="daterange"></DatePicker>
      </Form-item>
      <Form-item label="离职日期：" prop="roleName">
        <DatePicker placeholder="请选择" placement="bottom-end" style="width: 200px"
                    type="daterange"></DatePicker>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')">重置</Button>
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button class="btn" type="primary" @click="examineShow(1)">添加员工</Button>
      <Button class="btn" type="primary" @click="examineShow(1)">下载花名册模板</Button>
      <Button class="btn" type="primary" @click="examineShow(1)">导入花名册</Button>
      <Button class="btn" type="primary" @click="examineShow(1)">导出员工名单</Button>
      <Button class="btn" type="primary" @click="examineShow(1)">批量离职</Button>
    </div>
    <div>
      <Table :columns="roleColumns" :data="roleTableData" :loading="loading" aria-describedby=""
             aria-hidden="true" border @on-selection-change="selectionChange">
        <template slot="employeeJobForm" slot-scope="{ row }">
          <span>
            {{
              row.employeeJobForm == 1 ? '自有' : row.employeeJobForm == 2 ? '外包' :
                row.employeeJobForm == 3 ? '派遣' : row.employeeJobForm == 4 ? '项目' : ''
            }}
          </span>
        </template>
        <template slot="employeeIsOnJob" slot-scope="{ row }">
          <span>
            {{ row.employeeIsOnJob ? '在职' : '离职' }}
          </span>
        </template>
        <template slot="employeeJobType" slot-scope="{ row }">
          <span>
            {{ row.employeeJobType == 1 ? '全职' : row.employeeJobType == 2 ? '兼职' : '实习' }}
          </span>
        </template>

        <template slot="action" slot-scope="{ row }">
          <Button size="small" type="text" @click="editShow(row)">编辑</Button>
          <Button size="small" type="text">签订电子合同</Button>
          <Button size="small" type="text" @click="quitShow(row)">离职</Button>
          <Button size="small" type="text" @click="deleteroster(row)">删除</Button>
        </template>
      </Table>
      <Page ref="pages" :current="page" :total="total" class="page_position" show-elevator show-sizer show-total
            @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="添加员工"
      width="800px"
    >
      <Form ref="addForm" :label-width="120" :model="addform" :rules="addRules" inline>
        <Form-item label="姓名：" prop="employeeRealName">
          <Input v-model="addform.employeeRealName" :maxlength="50" clearable placeholder="请输入"
                 style="width: 200px"></Input>
        </Form-item>
        <Form-item label="手机号：" prop="employeeMobilephone">
          <Input v-model="addform.employeeMobilephone" :maxlength="50" clearable placeholder="请输入"
                 style="width: 200px"></Input>
        </Form-item>
        <Form-item label="证件类型：" prop="employeeCertificateType">
          <Select v-model="addform.employeeCertificateType" clearable filterable style="width: 200px">
            <Option value="1">居民身份证</Option>
            <Option value="2">外国护照</Option>
            <Option value="3">中国护照</Option>
            <Option value="4">港澳居民来往内地通行证</Option>
            <Option value="5">港澳居民居住证</Option>
            <Option value="6">台湾居民来往大陆通行证</Option>
            <Option value="7">台湾居民居住证</Option>
            <Option value="8">外国人永久居留身份证</Option>
            <Option value="9">外国人工作许可证（A类）</Option>
            <Option value="10">外国人工作许可证（B类）</Option>
            <Option value="11">外国人工作许可证（C类）</Option>
            <Option value="99">其他</Option>
          </Select>
        </Form-item>
        <Form-item label="证件号码：" prop="employeeIdNumber">
          <Input v-model="addform.employeeIdNumber" :maxlength="50" clearable placeholder="请输入"
                 style="width: 200px"></Input>
        </Form-item>
        <Form-item label="入职日期：" prop="employeeEntryDate">
          <DatePicker v-model="addform.employeeEntryDate" placeholder="选择入职日期"
                      style="width: 200px" type="date"></DatePicker>
        </Form-item>
        <Form-item label="员工类型：" prop="employeeJobType">
          <Select v-model="addform.employeeJobType" clearable filterable style="width: 200px">
            <Option value="1">全职</Option>
            <Option value="2">兼职</Option>
            <Option value="3">实习</Option>
          </Select>
        </Form-item>
        <Form-item label="厂站：">
          <Cascader v-model="addform.deptId" :data="tableDataDeptList" change-on-select filterable
                    not-found-text='暂无下级数据，请创建'
                    style="width: 200px" @on-change="changedeptIdAdd"></Cascader>
        </Form-item>
        <Form-item label="用工形式：">
          <Select v-model="addform.employeeJobForm" clearable filterable style="width: 200px">
            <Option value="1">自有</Option>
            <Option value="2">外包</Option>
            <Option value="3">派遣</Option>
            <Option value="4">项目</Option>
          </Select>
        </Form-item>
        <Form-item label="岗位：">
          <Input v-model="addform.employeeResponsibilitie" :maxlength="50" clearable placeholder="请输入"
                 style="width: 200px"></Input>
        </Form-item>
        <Form-item label="工种：">
          <Input v-model="addform.employeeWorktypeName" :maxlength="50" clearable placeholder="请输入"
                 style="width: 200px"></Input>
        </Form-item>


        <Form-item>
          <Button class="next" type="primary" @click="examine">提交</Button>
        </Form-item>
      </Form>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisibleEdit"
      title=""
      width="1000px"
    >
      <personal-files></personal-files>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisibleQuit"
      title="员工离职"
      width="400px"
    >
      <Form ref="quitForm" :label-width="120" :model="addform" :rules="addRules">
        <Form-item label="姓名：">
          <p>{{ row.employeeRealName }}</p>
        </Form-item>
        <Form-item label="手机号：">
          <p>{{ row.employeeMobilephone }}</p>
        </Form-item>

        <Form-item label="离职日期：" prop="employeeResignationDate">
          <DatePicker v-model="quitform.employeeResignationDate" placeholder="选择入职日期" style="width: 200px"
                      type="date" @on-change="quitDate"></DatePicker>
        </Form-item>
        <Form-item label="离职原因：" prop="employeeResignationReason">
          <Input v-model="quitform.employeeResignationReason" :maxlength="50" clearable placeholder="请输入"
                 style="width: 200px"></Input>
        </Form-item>
        <Form-item label="是否开具离职证明：">
          <RadioGroup v-model="quitform.issuedResignation">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </Form-item>
        <Form-item label="岗位：">
          <Input v-model="quitform.emplyeResponsiblitie"
                 :disabled="quitform.issuedResignation=='0'" :maxlength="50"
                 clearable placeholder="请输入"
                 style="width: 200px"></Input>
        </Form-item>
        <Form-item>
          <Button class="next" type="primary" @click="quit">确认</Button>
        </Form-item>
      </Form>
    </el-dialog>
  </div>
</template>

<script>
import {
  companyEmployeeAdd,
  companyEmployeeDelete,
  companyEmployeePage,
  companyEmployeeQuit,
  deptList
} from '@/api/organization'
import {allDivisionTree} from '@/api/public'
import personalFiles from './personalFiles.vue'

export default {
  name: 'role',
  filters: {
    setRoleType: function (value) {
      switch (value) {
        case 0:
          return '超级管理员'
        case 1:
          return '客户企业角色'
        default:
          return '系统找不到'
      }
    }
  },
  components: {
    personalFiles
  },
  data() {
    return {
      employeeCertificateTypeList: [],
      reasonsRefusal: "",
      animal: '',
      total: 0,
      dialogVisible: false,
      dialogVisibleQuit: false,
      dialogVisibleEdit: false,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      lockMsg: '', // 锁定/解锁
      lockStatus: '', //锁定/解锁状态
      btnList: [],
      companyIds: '',
      scaleOptions: [{
        value: 1,
        label: '10人以下'
      }, {
        value: 2,
        label: '10-50人'
      }, {
        value: 3,
        label: '50-100人'
      }, {
        value: 4,
        label: '100-500人'
      }, {
        value: 5,
        label: '500-1000人'
      }, {
        value: 6,
        label: '1000-5000人'
      }, {
        value: 7,
        label: '5000-20000人'
      }, {
        value: 8,
        label: '2万-10万人'
      }, {
        value: 9,
        label: '10万人以上'
      }],
      formCustom: {
        employeeRealName: '',
        employeeMobilephone: '',
        employeeCertificateType: '',
        employeeIdNumber: '',
        employeeEntryDate: '',
        employeeJobType: '',
        deptId: '',
        employeeJobForm: '',
        employeeResponsibilitie: '',
        employeeWorktypeName: '',
        employeeIsOnJob: '',
      },
      addform: {
        employeeRealName: '',
        employeeMobilephone: '',
        employeeCertificateType: '',
        employeeIdNumber: '',
        employeeEntryDate: '',
        employeeJobType: '',
        deptId: '',
        employeeJobForm: '',
        employeeResponsibilitie: '',
        employeeWorktypeName: '',
      },
      quitform: {
        employeeResignationReason: '',
        employeeResignationDate: '',
        issuedResination: '',
        emplyeResponsiblitie: '',
      },
      roleColumns: [
        {type: 'selection', width: 60, align: 'center'},
        {title: '姓名', key: 'employeeRealName', align: 'center'},
        {title: '证件号码', key: 'employeeIdNumber', align: 'center'},
        {title: '手机号', key: 'employeeMobilephone', align: 'center'},
        {title: '厂站', key: 'deptName', align: 'center'},
        {title: '岗位', key: 'employeeResponsibilitie', align: 'center'},
        {title: '工种', key: 'employeeWorktypeName', align: 'center'},
        {title: '员工类型', key: 'employeeJobType', slot: 'employeeJobType', align: 'center'},
        {title: '用工形式', key: 'employeeJobForm', slot: 'employeeJobForm', align: 'center'},
        {title: '在职状态', key: 'employeeIsOnJob', slot: 'employeeIsOnJob', align: 'center'},
        {title: '入职日期', key: 'employeeEntryDate', align: 'center'},
        {title: '离职日期', key: 'employeeResignationDate', align: 'center'},
        {title: '操作', slot: 'action', align: 'center', fixed: 'right'}

      ],
      roleTableData: [], // 表格数据
      areaData: [],
      props: {value: 'id'},
      countyCode: '',
      row: {},
      addRules: {
        employeeRealName: [{required: true, message: '姓名不能为空', trigger: 'blur'}],
        employeeIdNumber: [{required: true, message: '证件号码不能为空', trigger: 'blur'}],
        employeeMobilephone: [{required: true, message: '手机号不能为空', trigger: 'blur'}],
        employeeCertificateType: [{required: true, message: '证件类型不能为空', trigger: 'blur'}],
        employeeEntryDate: [{required: true, message: '入职日期不能为空', trigger: 'blur'}],
        employeeJobType: [{required: true, message: '员工类型不能为空', trigger: 'blur'}],
      },
      quitRules: {
        employeeResignationReason: [{required: true, message: '离职原因不能为空', trigger: 'blur'}],
        employeeResignationDate: [{required: true, message: '离职日期不能为空', trigger: 'blur'}],
        emplyeResponsiblitie: [{required: true, message: '证件类型不能为空', trigger: 'blur'}],
      },
      tableDataDeptList: []
    }
  },
  mounted() {
    this.init()
    deptList({companyId: ''}).then((res) => {
      if (res.data.success) {
        this.tableDataDeptList = res.data.data
      }
    })
  },
  methods: {
    // 初始化
    init() {
      this.loading = true
      this.addform = {
        employeeRealName: '',
        employeeMobilephone: '',
        employeeCertificateType: '',
        employeeIdNumber: '',
        employeeEntryDate: '',
        employeeJobType: '',
        deptId: '',
        employeeJobForm: '',
        employeeResponsibilitie: '',
        employeeWorktypeName: '',
      }
      this.quitform = {
        employeeResignationReason: '',
        employeeResignationDate: '',
        issuedResignation: '1',
        emplyeeResponsibilitie: '',
      }
      companyEmployeePage({
        current: 1,
        size: 10,
      }).then((res) => {

        this.changeData(res)
      })
      allDivisionTree({}).then((response) => {
        this.areaData = response.data.data
      })
    },
    changedeptId(v, d) {
      this.formCustom.deptId = d.slice(-1)[0].id
    },
    changedeptIdAdd(v, d) {
      this.addform.deptId = d.slice(-1)[0].id
    },
    quitDate(a, b) {
      console.log(a, b)
      this.quitform.employeeResignationDate = a
    },
    examineShow(row) {
      this.row = row
      this.dialogVisible = true
    },
    selectionChange(s) {
      if (s && s.length > 0) {
        let a = []
        s.forEach(e => {
          a.push(e.companyId)
        })
        this.companyIds = a.join(",")
      }
    },
    handleReset(name) {
      this.$refs[name].resetFields()
      // 重置查询条件会再次查询
      this.handleSearch()
    },
    examine() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          companyEmployeeAdd({...this.addform}).then((res) => {
            if (res.data.success) {
              this.dialogVisible = false
              this.init()
            }
          })
        }
      })
    },
    quitShow(row) {
      this.row = row
      this.dialogVisibleQuit = true
    },
    editShow(row) {
      this.row = row
      this.dialogVisibleEdit = true
    },
    quit() {
      companyEmployeeQuit({companyEmployeeId: this.row.companyEmployeeId, ...this.quitform}).then((res) => {
        if (res.data.success) {
          this.$Message.success('职工离职成功!');
          this.init()
        }
      })
    },
    deleteroster(row) {
      companyEmployeeDelete({companyEmployeeId: row.companyEmployeeId}).then((res) => {
        if (res.data.success) {
          this.$Message.success('职工删除成功!');
          this.init()
        }
      })
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.roleTableData = res.data.data.records
      res.data.data.records.forEach((element, index) => {
        if (element.status === -1) {
          this.roleTableData[index].status = '锁定'
        } else if (element.status === 1) {
          this.roleTableData[index].status = '有效'
        }
      })
      this.loading = false
    },
    // 查询
    handleSearch() {
      const data = {
        ...this.formCustom
      };
      companyEmployeePage({
        current: 1,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 改变页码
    setCurrent(val) {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      this.loading = true
      this.page = val
      companyEmployeePage({
        current: val,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 改变每页条数
    setPage(val) {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      this.loading = true
      this.pageSize = val
      companyEmployeePage({
        current: 1,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    }
  }
}
</script>
<style lang="less">
html, body {
  // overflow: hidden;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
}

.next {
  border-radius: 4px;
  background-color: rgba(0, 123, 211, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  height: 50px;
  border-color: #3A62D7;
  width: 90px;
}

.btn {
  margin-left: 30px;
  margin-top: 10px;
}
</style>
